import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarketingCoverageComponent } from './marketing-coverage.component';
import { AppAnalyticsModule } from '../../directives/app-analytics.module';

@NgModule({
    imports: [CommonModule, AppAnalyticsModule],
    declarations: [MarketingCoverageComponent],
    exports: [MarketingCoverageComponent],
})
export class MarketingCoverageModule {}
